import { useEffect, useState } from 'react';
import { siteCalculationState } from '../services/siteCalculationState';
import { CalculationType } from '../@types/enums';

type CalculationOption = {
    useCalculation?: boolean,
}

export function useCalculationStates(names: CalculationType[], options?: CalculationOption) {
    const [needsUpdate, setNeedsUpdate] = useState<{ [value in CalculationType]?: boolean }>
    (names.reduce<{ [value in CalculationType]?: boolean }>((p, c) => {
        p[c] = siteCalculationState.doesNeedUpdateOrUpdating(c);
        return p;
    }, {}));

    useEffect(() => {
        const needsUpdateListener = (e: any) => {
            setNeedsUpdate(state => ({ ...state, [e.detail.name]: true }));
        }

        const updatedListener = (e: any) => {
            setNeedsUpdate(state => ({ ...state, [e.detail.name]: false }));
        };

        for (const name of names) {
            siteCalculationState.addNeedsUpdateListener(name, needsUpdateListener);
            siteCalculationState.addUpdatedListener(name, updatedListener);
        }

        return () => {
            for (const name of names) {
                siteCalculationState.removeNeedsUpdateListener(name, needsUpdateListener);
                siteCalculationState.removeUpdatedListener(name, updatedListener);
            }
        };
    }, [names]);

    if (options?.useCalculation) {
        siteCalculationState.useCalculations(...names);
    }

    return {
        needsUpdate,
    };
}

export function useCalculationState(name: CalculationType, options?: CalculationOption) {
    const {needsUpdate} = useCalculationStates([name], options);

    return {
        needsUpdate: needsUpdate[name],
    };
}
